import React from 'react';

interface VideoPlayerProps {
  videoUrl: string;
  videoType: 'youtube' | 'vimeo' | 'mp4';
  className?: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ videoUrl, videoType, className = '' }) => {
  const getEmbedUrl = () => {
    if (videoType === 'youtube') {
      // Extract video ID from various YouTube URL formats
      let videoId = '';

      if (videoUrl.includes('youtu.be/')) {
        videoId = videoUrl.split('youtu.be/')[1].split('?')[0];
      } else if (videoUrl.includes('youtube.com/watch?v=')) {
        videoId = videoUrl.split('watch?v=')[1].split('&')[0];
      } else if (videoUrl.includes('youtube.com/embed/')) {
        videoId = videoUrl.split('embed/')[1].split('?')[0];
      } else if (videoUrl.includes('youtube.com/v/')) {
        videoId = videoUrl.split('youtube.com/v/')[1].split('?')[0];
      }

      // Add origin parameter for better compatibility
      const origin = window.location.origin;
      return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&origin=${encodeURIComponent(origin)}&enablejsapi=1`;
    }

    if (videoType === 'vimeo') {
      // Extract video ID from Vimeo URL
      const videoId = videoUrl.split('vimeo.com/')[1]?.split('?')[0];
      return `https://player.vimeo.com/video/${videoId}?byline=0&portrait=0`;
    }

    // For MP4, return the URL as-is
    return videoUrl;
  };

  if (videoType === 'mp4') {
    return (
      <video
        className={`video-player ${className}`}
        controls
        preload="metadata"
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      >
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    );
  }

  // YouTube or Vimeo iframe
  return (
    <iframe
      className={`video-player ${className}`}
      src={getEmbedUrl()}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      referrerPolicy="strict-origin-when-cross-origin"
      style={{ width: '100%', height: '100%' }}
      title="Intro Video"
    />
  );
};

export default VideoPlayer;
